export default __webpack_public_path__ + "static/media/img-profile-bg.628af8c3.png";